//  Time-stamp: "2016-07-25 06:42:32 MDT"
module.exports = [
'k', 'kh', 'g', 'gh', 'ng', 'c', 'ch', 'j', 'jh', 'ny', 'nny', 'tt', 'tth', 'dd', 'ddh', 'nn',
'tt', 'th', 'd', 'dh', 'n', 'p', 'ph', 'b', 'bh', 'm', 'y', 'r', 'l', 'w', 's', 'h',
'll', 'a', '[?]', 'i', 'ii', 'u', 'uu', 'e', '[?]', 'o', 'au', '[?]', 'aa', 'i', 'ii', 'u',
'uu', 'e', 'ai', '[?]', '[?]', '[?]', 'N', "'", ":", "", '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
'0', '1', '2', '3', '4', '5', '6', '7', '8', '9', " / ", " // ", "n*", "r*", "l*", "e*",
'sh', 'ss', 'R', 'RR', 'L', 'LL', 'R', 'RR', 'L', 'LL', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
'[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
'[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
'[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
'[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
'A', 'B', 'G', 'D', 'E', 'V', 'Z', "T`", 'I', 'K', 'L', 'M', 'N', 'O', 'P', 'Zh',
'R', 'S', 'T', 'U', "P`", "K`", "G'", 'Q', 'Sh', "Ch`", "C`", "Z'", 'C', 'Ch', 'X', 'J',
'H', 'E', 'Y', 'W', 'Xh', 'OE', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
'a', 'b', 'g', 'd', 'e', 'v', 'z', "t`", 'i', 'k', 'l', 'm', 'n', 'o', 'p', 'zh',
'r', 's', 't', 'u', "p`", "k`", "g'", 'q', 'sh', "ch`", "c`", "z'", 'c', 'ch', 'x', 'j',
'h', 'e', 'y', 'w', 'xh', 'oe', 'f', '[?]', '[?]', '[?]', '[?]', " // ", '[?]', '[?]', '[?]', '[?]',
];
